import React from 'react'
import styled from 'styled-components'
import { useObserver } from 'mobx-react'
import { Alert } from 'react-bootstrap'
import useStores from '../../stores/useStore'
import AddSubheader from '../../components/Assets/AddAsset/AddSubheader'
import Sidebar from '../../components/Assets/AddAsset/Sidebar'
import AddContentArea from '../../components/Assets/AddAsset/AddContentArea'
import AssetDataProvider from '../../stores/AssetDataProvider'
import { StyledJobfunctionContainer } from '../../components/Assets/Form/formHelper'
import { useTranslation } from 'react-i18next'
import { ContentArea } from '../../components/Page/logix2020/ContentArea'
import { TestSidebarRight } from '../../components/Page/logix2020/TestSidebarRight'
import BigFooter from '../../components/Footer/BigFooter'
import { FlexWrapper } from '../../components/Page/logix2020/FlexWrapper'

const StyledContentArea = styled(ContentArea)`
   padding: 20px 40px 20px 36px;
   @media (max-width: 1080px) {
    padding: 20px;
    min-height: calc(100vh - 488px);//header+navbar+sidebar=488px
   }
   .added-row {
    label {
      display: block;
    }
  }
`

const AddAssetPage = () => {
  const { uiStore } = useStores()
  const { t } = useTranslation()

  return useObserver(() => (
    <AssetDataProvider>
      <StyledJobfunctionContainer>
        {!uiStore.allowAssetEntitiesAdministration ? (
          <>
            <StyledContentArea>
              <Alert variant="danger">{t('addAssetPage:addAssetAlert')}</Alert>
            </StyledContentArea>
          </>
        ) : (
          <>
            <AddSubheader />
            <FlexWrapper>
              <StyledContentArea>
                <AddContentArea />
              </StyledContentArea>
              <TestSidebarRight>
                <Sidebar />
              </TestSidebarRight>
            </FlexWrapper>
            <BigFooter />
          </>
        )}
      </StyledJobfunctionContainer>
    </AssetDataProvider>

  ))
}

export default AddAssetPage


